import React from "react";
import { Code } from "./_styles";

const NotFound = () => (
  <Code>
    {"{"}--<span>:+404 NOT FOUND++:</span>--{"}"}
  </Code>
);

export default NotFound;
